import { Fragment, FunctionalComponent, h } from "@stencil/core";

export const EmptyBoxComponent: FunctionalComponent = () => (
  <Fragment>
    <div slot="inner-box">
      <div class="row">
        <div class="col-8">
          <h2>CO2 (KG)</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-8 emissions-figure">
          <span>00.00</span>
        </div>
      </div>
    </div>
  </Fragment>
);
